import { render, staticRenderFns } from "./comp_ProductPage-DeliveryCalc-Results.vue?vue&type=template&id=c3c2ed08&scoped=true&"
import script from "./comp_ProductPage-DeliveryCalc-Results.vue?vue&type=script&lang=js&"
export * from "./comp_ProductPage-DeliveryCalc-Results.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductPage-DeliveryCalc-Results.vue?vue&type=style&index=0&id=c3c2ed08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c2ed08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VDivider,VSpacer})
